import React from 'react';
import {
  Link
} from 'react-router-dom'
import NavBar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import chestPain from "./chest_pain.jpg";
import './Solution.css';

const Solution = () => {
  document.title = 'For Individuals | Xtendliving';
  return (
    <div>
      <NavBar />
      <div className="container" style={{marginBottom: 70}}>
        <h3>For Individuals</h3>
      </div>
      <div className="container">
        <iframe className="solutionVideo" title="h" src="https://www.youtube.com/embed/_HEnohs6yYw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      <div className="container" style={{marginTop: 70}}>
        <h5 className="" style={{color:'#EE4142'}}>Visiting the doctor’s office has become a burden and an inconvenience. In fact, most people try to self-diagnose and self-treat rather than take a trip to the doctor’s office.</h5>
        <h6  style={{fontWeight:'bold', color: '#6D7A8C'}}>With Xtendliving you don’t need to:</h6>
        <ol style={{paddingLeft: 5, fontSize:17}}>
          <li>Pay for expensive treatment and or unnecessary medications</li>
          <li>Leave your home</li>
          <li>Miss work for unnecessary clinic and or hospital visits</li>
          <li>Get stuck in traffic</li>
          <li>Wait for a long time for an appointment</li>
          <li>Be rushed</li>
        </ol>
        <br />
        <br />
        <hr />
        <p style={{ }}>Now you have access to honest, reliable, convenient and cost-effective care – all at the click of a button! Our doctors will give you honest medical advice based on Evidence Based Medicine.</p>
      </div>
      <div className="container" style={{backgroundColor: 'black', padding:50}}>
        <div className="container">
          <h2 className="white-text">Xtendliving</h2>
          <h5 className="white-text">A true healthcare solution</h5>
        </div>
      </div>
      <div className="container">
        <h4>How It Works</h4>
        <p style={{fontSize:17}}>With Xtendliving, you have access to quality, convenient and quick care starting from the moment you access our physician helpline (via our interactive mobile application called Xtendliving or 08000XTEND(08000xxxxxx)) to the point of recovery.</p>
        <ol style={{paddingLeft: 5, fontSize:17}}>
          <li>Download our mobile application, available on Google Play and App Store – set up your account</li>
          <li>Call Xtendliving, anytime, from anywhere in the world for honest medical and wellness advice on your condition</li>
          <li>Get a referral, doctor’s appointment or medication delivered to your doorstep</li>
          <li>Receive a follow-up call. We offer our members continuous support by following up until the point of recovery</li>
        </ol>
      </div>
      <div className="container" >
        <div className="section">
          <div className="row">
            <div className="col s12 m6">
              <img src={chestPain} className="chestImg" alt="chest pain" />
            </div>
            <div className="col s12 m6" style={{paddingLeft:20}}>
              <h6  style={{fontWeight:'bold', fontSize: 20}}>Benefits for Individuals</h6>
              <ol style={{paddingLeft: 5, fontSize:17}}>
                <li>Pay for expensive treatment and or unnecessary medications</li>
                <li>Leave your home</li>
                <li>Miss work for unnecessary clinic and or hospital visits</li>
                <li>Get stuck in traffic</li>
                <li>Wait for a long time for an appointment</li>
                <li>Be rushed</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="" style={{backgroundColor: '#EDF9F7', paddingTop:50, paddingBottom:50}}>
        <h3 className="center">Want to know More?</h3>
        <div className="center">
          <p style={{color: '#6D7A8C'}}>Contact us for more information</p> {/*waves-effect waves-light blue lighten-1*/}
          <Link to="/specialoffer" id="download-button" className="btn-large" style={{backgroundColor: '#EE4142'}}>Sign Up</Link>
        </div>
      </div>
      <div style={{paddingTop:50}}>
      </div>

      <Footer />
    </div>
  )
}

export default Solution;